import React, { useState } from "react";
import "./AddJobForm.css";
import axios from "axios"; // Import Axios library

const AddJobForm = () => {
  const [jobId, setJobId] = useState("");
  const [jobTitle, setJobTitle] = useState("");
  const [jobDescription, setJobDescription] = useState("");
  const [location, setLocation] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [link, setLink] = useState("");
  const [isFormValid, setIsFormValid] = useState(false);

  const addJob = async () => {
    try {
      // Construct the job object
      const jobData = {
        job_id: jobId,
        title: jobTitle,
        description: jobDescription,
        location: location,
        companyName: companyName,
        link: link,
      };

      // Send a POST request to the server with job data
      const response = await axios.post(
        "https://securenet-backend.vercel.app/submit-job",
        jobData
      );

      // Handle success response
      console.log(response.data.message);
      alert("Job posted successfully!");

      // Reset the form fields
      setJobId("");
      setJobTitle("");
      setJobDescription("");
      setLocation("");
      setCompanyName("");
      setLink("");
      setIsFormValid(false); // Reset form validation
    } catch (error) {
      // Handle error response
      console.error("Error posting job:", error);
      alert("Failed to post job. Please try again later.");
    }
  };

  // Function to generate job ID
  const generateJobId = () => {
    const alphanumeric =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let jobId = "";
    for (let i = 0; i < 22; i++) {
      jobId += alphanumeric.charAt(
        Math.floor(Math.random() * alphanumeric.length)
      );
    }
    setJobId(jobId); // Set the generated job ID
  };

  // Function to handle form validation
  const handleFormValidation = () => {
    setIsFormValid(
      jobTitle && jobDescription && location && companyName && link
    );
  };

  return (
    <div className="add-job-container">
      <h2>Add a Job</h2>
      <label>Job ID:</label>
      <div className="input-group generate-id-container">
        <input
          type="text"
          value={jobId}
          onChange={(e) => setJobId(e.target.value)}
        />
        <button className="generate-id-btn" onClick={generateJobId}>
          Generate ID
        </button>
      </div>

      <div className="input-group">
        <label>Job Title:</label>
        <input
          type="text"
          value={jobTitle}
          onChange={(e) => setJobTitle(e.target.value)}
          onBlur={handleFormValidation}
        />
      </div>
      <div className="input-group">
        <label>Job Description:</label>
        <textarea
          value={jobDescription}
          onChange={(e) => setJobDescription(e.target.value)}
          onBlur={handleFormValidation}
        />
      </div>
      <div className="input-group">
        <label>Location:</label>
        <input
          type="text"
          value={location}
          onChange={(e) => setLocation(e.target.value)}
          onBlur={handleFormValidation}
        />
      </div>
      <div className="input-group">
        <label>Company Name:</label>
        <input
          type="text"
          value={companyName}
          onChange={(e) => setCompanyName(e.target.value)}
          onBlur={handleFormValidation}
        />
      </div>
      <div className="input-group">
        <label>Link:</label>
        <input
          type="text"
          value={link}
          onChange={(e) => setLink(e.target.value)}
          onBlur={handleFormValidation}
        />
      </div>
      <button className="add-job-btn" onClick={addJob} disabled={!isFormValid}>
        Post Job
      </button>
    </div>
  );
};

export default AddJobForm;
